<template>
  <vue-good-table :columns="spec.columns" :rows="spec.rows.dummyRows">
    <template slot="table-row" slot-scope="props">
      <template v-if="props.column.field == 'item1'">
        <div style="max-width: 250px">
          {{
            spec.rows.group1[props.row.originalIndex]
              ? $t(
                  `occupationalService.compiledReport.${parseKey(
                    spec.rows.group1[props.row.originalIndex].key
                  )}`
                )
              : ""
          }}

        </div>
      </template>
      <template v-else-if="props.column.field == 'value1'">
        <div class="modal-col-size-100" :class="(spec.rows.group1[props.row.originalIndex] && compiledData[`${spec.rows.group1[props.row.originalIndex].key}-level`] ? compiledData[`${spec.rows.group1[props.row.originalIndex].key}-level`] : checkTableStyle(spec.rows.group1[props.row.originalIndex]))">
          {{
            spec.rows.group1[props.row.originalIndex]
              ? compiledData[spec.rows.group1[props.row.originalIndex].key]
              : ""
          }}
        </div>
      </template>
      <template v-if="props.column.field == 'item2'">
        <div style="max-width: 250px">
          {{
            spec.rows.group2[props.row.originalIndex]
              ? $t(
                  `occupationalService.compiledReport.${parseKey(
                    spec.rows.group2[props.row.originalIndex].key
                  )}`
                )
              : ""
          }}
        </div>
      </template>
      <template v-else-if="props.column.field == 'value2'">
        <div class="modal-col-size-100" :class="spec.rows.group2[props.row.originalIndex] && compiledData[`${spec.rows.group2[props.row.originalIndex].key}-level`] ? compiledData[`${spec.rows.group2[props.row.originalIndex].key}-level`] : checkTableStyle(spec.rows.group2[props.row.originalIndex])">
          {{
            spec.rows.group2[props.row.originalIndex]
              ? compiledData[spec.rows.group2[props.row.originalIndex].key]
              : ""
          }}
        </div>
      </template>
      <template v-if="props.column.field == 'item3'">
        <div style="max-width: 250px">
          {{
            spec.rows.group3[props.row.originalIndex]
              ? $t(
                  `occupationalService.compiledReport.${parseKey(
                    spec.rows.group3[props.row.originalIndex].key
                  )}`
                )
              : ""
          }}
        </div>
      </template>
      <template v-else-if="props.column.field == 'value3'">
        <div class="modal-col-size-100" :class="spec.rows.group3[props.row.originalIndex] && compiledData[`${spec.rows.group3[props.row.originalIndex].key}-level`] ? compiledData[`${spec.rows.group3[props.row.originalIndex].key}-level`] : checkTableStyle(spec.rows.group3[props.row.originalIndex])">
          {{
            spec.rows.group3[props.row.originalIndex]
              ? compiledData[spec.rows.group3[props.row.originalIndex].key]
              : ""
          }}
        </div>
      </template>
    </template>
  </vue-good-table>
</template>
<script>
export default {
  name: 'CompiledReportTableComponents',
  props: {
    compiledData: {
      type: Object,
      required: true,
    },
    isPrint: { default: false, type: Boolean },
  },
  data() {
    return {
      spec: {
        columns: [
          {
            label: 'Row 1 Item',
            field: 'item1',
            thClass: 'd-none',
            tdClass: 'text-center bg-item',
            sortable: false,
          },
          {
            label: 'Row 1 Value',
            field: 'value1',
            thClass: 'd-none',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            label: 'Row 2 Item',
            field: 'item2',
            thClass: 'd-none',
            tdClass: 'text-center bg-item',
            sortable: false,
          },
          {
            label: 'Row 2 Value',
            field: 'value2',
            thClass: 'd-none',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            label: 'Row 3 Item',
            field: 'item3',
            thClass: 'd-none',
            tdClass: 'text-center bg-item',
            sortable: false,
          },
          {
            label: 'Row 3 Value',
            field: 'value3',
            thClass: 'd-none',
            tdClass: 'text-center',
            width: '100px',
            sortable: false,
          },
        ],
        rows: {
          dummyRows: [],
          group1: [
            { key: 'healthCare-year' },
            { key: 'healthCare-month' },
            { key: 'healthCare-employeeNo' },
            { key: 'employeeName' },
            { key: 'departmentCode' },
            { key: 'departmentName' },
            { key: 'jobPosition' },
            { key: 'gender' },
            { key: 'birthOfDate' },
            { key: 'age' },
            { key: 'ageRange' },
            { key: 'H01' },
            { key: 'H02' },
            { key: 'H04' },
            { key: 'H05' },
            { key: 'H06' },
            { key: 'H10' },
            { key: 'H11' },
            { key: 'H14' },
            { key: 'H15' },
            { key: 'H16' },
            { key: 'H17' },
            { key: 'H36' },
            { key: 'H37' },
            { key: 'framinghamRiskScore' },
            { key: 'cardiovascularDiseaseRiskLevel' },
            { key: 'adultBloodPressureClassification' },
            { key: 'bmiClassification' },
            { key: 'metabolicSyndromeClassification' },
            { key: 'chronicDiseaseGroupClassification' },
          ],
          group2: [
            { key: 'workload-year' },
            { key: 'workload-month' },
            { key: 'I01' },
            { key: 'I02' },
            { key: 'I03' },
            { key: 'I04' },
            { key: 'I05' },
            { key: 'I06' },
            { key: 'iScore' },
            { key: 'iRisk' },
            { key: 'J01' },
            { key: 'J02' },
            { key: 'J03' },
            { key: 'J04' },
            { key: 'J05' },
            { key: 'J06' },
            { key: 'J07' },
            { key: 'jScore' },
            { key: 'jRisk' },
            { key: 'H38' },
            { key: 'jobTypeAssessmentLevel' },
            { key: 'workloadLevel' },
            { key: 'cardiovascularDiseaseRiskLevel' },
            { key: 'abnormalWorkloadPromotesDiseaseRiskLevel' },
          ],
          group3: [
            { key: 'personal-year' },
            { key: 'personal-month' },
            { key: 'personal-employeeNo' },
            { key: 'seniority' },
            { key: 'allergyHistory' },
            { key: 'betelNut' },
            { key: 'alcohol' },
            { key: 'travelHistory' },
            { key: 'nmq-year' },
            { key: 'nmq-month' },
            { key: 'q1' },
            { key: 'q2' },
            { key: 'q3' },
            { key: 'q4' },
            { key: 'other' },
            { key: 'description' },
            { key: 'neck' },
            { key: 'leftShoulder' },
            { key: 'rightShoulder' },
            { key: 'upperBack' },
            { key: 'lowerBack' },
            { key: 'leftArm' },
            { key: 'rightArm' },
            { key: 'leftWrist' },
            { key: 'rightWrist' },
            { key: 'leftTight' },
            { key: 'rightTight' },
            { key: 'leftKnee' },
            { key: 'rightKnee' },
            { key: 'leftAnkle' },
            { key: 'rightAnkle' },
          ],
        },
      },
    };
  },
  created() {
    const maxLength = Math.max(this.spec.rows.group1.length, this.spec.rows.group2.length, this.spec.rows.group3.length);

    for (let i = 0; i < maxLength; i++) {
      this.spec.rows.dummyRows.push({});
    }
  },
  methods: {
    parseKey(key) {
      let resultKey = '';

      if (key) {
        resultKey = key.includes('-') ? key.substring(key.lastIndexOf('-') + 1) : key;
      }

      return resultKey;
    },
    checkTableStyle(column) {
      let rtn = '';
      if (column === undefined || column === null) {
        return rtn;
      }
      const checkData = this.compiledData[column.key];
      if (checkData === undefined || checkData === null) {
        return rtn;
      }
      if (column.key === 'cardiovascularDiseaseRiskLevel') {
        switch (checkData) {
          case '低度風險 (心血管風險等級<10%)':
            rtn = 'background-level-1';
            break;
          case '中度風險 (心血管風險等級10%~20%)':
            rtn = 'background-level-2';
            break;
          case '高度風險 (心血管風險等級20%~30%)':
            rtn = 'background-level-3';
            break;
          case '極高風險 (心血管風險等級>30%)':
            rtn = 'background-level-4';
            break;
          default:
            rtn = '';
            break;
        }
        if (!this.isPrint) {
          rtn += ' modal-col-size-125';
        }
      } else if (column.key === 'abnormalWorkloadPromotesDiseaseRiskLevel') {
        if (checkData.indexOf('低度風險') >= 0) {
          rtn = 'background-level-1';
        }
        if (checkData.indexOf('中度風險') >= 0) {
          rtn = 'background-level-2';
        }
        if (checkData.indexOf('高度風險') >= 0) {
          rtn = 'background-level-3';
        }
        if (!this.isPrint) {
          rtn += ' modal-col-size-125';
        }
      }
      return rtn;
    },
  },
};
</script>
<style lang="scss" scoped>
.background-level-1 {
  width: initial !important;
  color: white;
  padding: 0.75em;
  margin: -0.75em !important;
  background-color: #58A707;
}
.background-level-2 {
  width: initial !important;
  color: black;
  padding: 0.75em;
  margin: -0.75em !important;
  background-color: #FFE247;
}
.background-level-3 {
  width: initial !important;
  color: white;
  padding: 0.75em;
  margin: -0.75em !important;
  background-color: #CF772F;
}
.background-level-4 {
  width: initial !important;
  color: white;
  padding: 0.75em;
  margin: -0.75em !important;
  background-color: #E20000;
}
.modal-col-size-125 {
  width: 125px !important;
}
.modal-col-size-100 {
  width: 100px;
  margin: auto;
}
.level-1 {
  font-weight: 700;
  color: #55a603;
}

.level-2 {
  font-weight: 700;
  color: #FFD600;
}

.level-3 {
  font-weight: 700;
  color: #c45902;
}

.level-4 {
  font-weight: 700;
  color: #e30000;
}
@media print {
  .background-level-1 {
    width: 125px !important;
    color: white;
    padding: 0.75em;
    margin: -0.75em;
    background-color: #58A707;
  }
  .background-level-2 {
    width: 125px !important;
    color: black;
    padding: 0.75em;
    margin: -0.75em;
    background-color: #FFE247;
  }
  .background-level-3 {
    width: 125px !important;
    color: white;
    padding: 0.75em;
    margin: -0.75em;
    background-color: #CF772F;
  }
  .background-level-4 {
    width: 125px !important;
    color: white;
    padding: 0.75em;
    margin: -0.75em;
    background-color: #E20000;
  }
}
</style>
